import { render } from "./a-mastertask-status.vue?vue&type=template&id=40b1e729"
import script from "./a-mastertask-status.vue?vue&type=script&lang=js"
export * from "./a-mastertask-status.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matejglasnak/gitrepo/jandl/jandl-taskmanager-app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__